// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateHistoryToDisplayCriteria = historyToDisplay => ({
    historyToDisplay,
    type: actions.UPDATE_SETTLEMENT_NO_REGISTRATION_HISTORY_TO_DISPLAY_CRITERIA
});

export const resetHistoryToDisplayCriteria = () => ({

    type: actions.RESET_SETTLEMENT_NO_REGISTRATION_HISTORY_TO_DISPLAY_CRITERIA

});



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/action-creators/criteria.js